const variantsMixin = {
    methods: {
        addClearanceItemToCart: function (variantSku, productId) {
            const vm = this;
           
            const variantSkus = {
                Skus: [variantSku]
            };

            const loader = document.querySelector('#addClearanceItemToCart-' + productId);
            loader.classList.remove('d-none');
            
            vm.addVariantItems(variantSkus)
                .then(function (response) {
                    if (!response)
                        return;

                    const content = response.data.content;

                    if (content.errors !== null) {
                        vueAddToCartModal.openError();
                    } else {
                        vueShoppingCartCount.total = content.basketItemsTotal;
                        vueProduct.quoteMe = content.quoteMe;
                        vueAddToCartModal.clearAddedProduct();
                        vueAddToCartModal.open();
                    }
                })
                .finally(() => {
                    loader.classList.add('d-none');
                });
        }
    }
}